// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__quR4S","title":"Info_title__2py2M","links":"Info_links__1NgKJ","link":"Info_link__-m3Ct","logo":"Info_logo__3j-rn"};